import styled, { css } from 'styled-components';
import { em, transparentize } from 'polished';
import { Swiper } from 'swiper/react';

import { GoldDark } from '../../modules/themes/themes/GoldDark';
import { SIZES } from '../internal/useWindowSize';

import prev from './prev.svg';
import next from './next.svg';

const SLIDE_WIDTH = 270;
const SLIDE_HEIGHT = 152;
export const MARGIN_WIDTH = 40;

const navigation = css`
  .swiper-button-prev,
  .swiper-button-next {
    width: ${({ theme }) => em(theme.honeycomb.size.large)};
    height: ${em(SLIDE_HEIGHT)};
    top: 0;
    margin: 0;
    cursor: pointer;
    background-color: ${transparentize(0.7, GoldDark.honeycomb.color.bg.tooltip.normal)};
    background-repeat: no-repeat;
    background-position: center;

    ::after {
      display: none;
    }
  }

  .swiper-button-prev {
    left: 0;
    background-image: url(${prev});
  }

  .swiper-button-next {
    right: 0;
    background-image: url(${next});
  }

  .swiper-button-disabled {
    display: none;
  }
`;

const pagination = css`
  .swiper-pagination {
    display: flex;
    justify-content: center;
    bottom: 0;

    .swiper-pagination-bullet {
      opacity: 1;
      background-color: ${({ theme }) => theme.honeycomb.color.text.disabled};
      margin: 0 ${em(2)};
    }

    .swiper-pagination-bullet-active {
      background-color: ${({ theme }) => theme.honeycomb.color.primary.normal};
    }
  }
`;

export const Styled = styled(Swiper)`
  border-radius: ${({ theme }) => em(theme.honeycomb.radius.normal)};
  overflow: hidden;

  .swiper-slide {
    border-radius: ${({ theme }) => em(theme.honeycomb.radius.normal)};
    overflow: hidden;
  }

  ${pagination};
  padding-bottom: ${({ theme }) => em(theme.honeycomb.size.small)};

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }

  @media (min-width: ${em(SIZES.md)}) {
    ${navigation};
    padding-bottom: 0;

    .swiper-slide {
      width: ${em(SLIDE_WIDTH)} !important;
      height: ${em(SLIDE_HEIGHT)} !important;
    }

    .swiper-button-prev,
    .swiper-button-next {
      :not(.swiper-button-disabled) {
        display: flex;
      }
    }

    .swiper-pagination {
      display: none;
    }
  }
`;
